import { render, staticRenderFns } from "./ImageAndName.vue?vue&type=template&id=b90448e4&scoped=true&"
import script from "./ImageAndName.vue?vue&type=script&lang=js&"
export * from "./ImageAndName.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndName.vue?vue&type=style&index=0&id=b90448e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90448e4",
  null
  
)

export default component.exports